import { SvgIconProps, useTheme } from '@mui/material';
import React from 'react';
import AnnualCost from '../../assets/icons/annual-cost.svg?react';
import Cooking from '../../assets/icons/cooking.svg?react';
import Floors from '../../assets/icons/floors.svg?react';
import HVAC from '../../assets/icons/hvac.svg?react';
import Landscape from '../../assets/icons/landscape.svg?react';
import Lighting from '../../assets/icons/lighting.svg?react';
import Monitoring from '../../assets/icons/monitoring.svg?react';
import People from '../../assets/icons/people.svg?react';
import PlugLoad from '../../assets/icons/plugload.svg?react';
import RectRight from '../../assets/icons/rect-right.svg?react';
import Specialized from '../../assets/icons/specialized.svg?react';
import WaterHeaters from '../../assets/icons/waterheaters.svg?react';
import WaterPumps from '../../assets/icons/waterpumps.svg?react';

type PaletteColor =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success';

export type IconKind =
  | 'AnnualCost'
  | 'Cooking'
  | 'Floors'
  | 'HVAC'
  | 'Landscape'
  | 'Lighting'
  | 'Monitoring'
  | 'People'
  | 'PlugLoad'
  | 'RectRight'
  | 'Specialized'
  | 'WaterHeaters'
  | 'WaterPumps';

export const IconWrapper: React.FC<
  Pick<SvgIconProps, 'color' | 'sx' | 'className'> & { icon?: IconKind }
> = ({ icon, sx, className, color }) => {
  const theme = useTheme();
  const Icon = getIcon(icon);

  if (Icon === React.Fragment) {
    return <React.Fragment />;
  }

  let paletteColor =
    color === undefined ? theme.palette.text.primary : 'inherit';
  if (color !== undefined) {
    const palette = theme.palette[color as PaletteColor];
    if (palette) {
      paletteColor = palette.main;
    }
  }

  const iconStyle: React.CSSProperties = {
    padding: '2px',
    color: paletteColor,
  };

  // Merge with sx if it's a simple object (not responsive or function)
  if (
    sx &&
    typeof sx === 'object' &&
    !Array.isArray(sx) &&
    !('function' in sx)
  ) {
    Object.assign(iconStyle, sx);
  }

  return <Icon className={className} style={iconStyle} />;
};

const getIcon = (icon?: IconKind) => {
  switch (icon) {
    case 'AnnualCost':
      return AnnualCost;
    case 'Cooking':
      return Cooking;
    case 'Floors':
      return Floors;
    case 'HVAC':
      return HVAC;
    case 'Landscape':
      return Landscape;
    case 'Lighting':
      return Lighting;
    case 'Monitoring':
      return Monitoring;
    case 'People':
      return People;
    case 'PlugLoad':
      return PlugLoad;
    case 'RectRight':
      return RectRight;
    case 'Specialized':
      return Specialized;
    case 'WaterHeaters':
      return WaterHeaters;
    case 'WaterPumps':
      return WaterPumps;
    default:
      return React.Fragment;
  }
};
